// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1714":"97361a83","4485":"4e489f7b","6243":"626a9a7d","6618":"956789a0","9804":"972af917"}[chunkId] + ".chunk.css";
};